// src/context/NotificationContext.js

import { createContext, useState } from 'react';

export const NotificationContext = createContext();

export function NotificationProvider({ children }) {
  const [messageCount, setMessageCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);

  return (
    <NotificationContext.Provider value={{
      messageCount,
      setMessageCount,
      notificationCount,
      setNotificationCount,
    }}>
      {children}
    </NotificationContext.Provider>
  );
}
